import React from 'react';

interface ProgressBarProps {
  progress: number;
  currentQuestion: number;
  totalQuestions: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  currentQuestion,
  totalQuestions,
}) => {
  return (
    <div className="w-full mb-6">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium" style={{ color: 'var(--wcag-text)' }}>
          Question {currentQuestion} sur {totalQuestions}
        </span>
        <span className="text-sm font-medium" style={{ color: 'var(--wcag-primary)' }}>
          {Math.round(progress)}%
        </span>
      </div>
      <div
        className="w-full rounded-full h-3 overflow-hidden"
        style={{ backgroundColor: 'var(--wcag-border)' }}
      >
        <div
          className="h-full rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progress}%`, backgroundColor: 'var(--wcag-primary)' }}
        />
      </div>
    </div>
  );
};
